import { useEffect, useRef, useState } from "react";
import { apiCall } from "../../../../utils/axiosService";
import { apiResponse } from "../../../../utils/apiResponse";
import { API_URL } from "../../../../utils/apiRoutes";
import { commonService } from "../../../../utils/commonService";
import Comments from "../Comments/Comment";
import { Button, Overlay, OverlayTrigger, Popover, Row, Table, Form } from "react-bootstrap";
import emailIcon from "../../../../Assets/Images/Email.svg";
import { useParams } from "react-router-dom";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { useSelector } from "react-redux";
import { compName } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";
import moment from "moment";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import Loader from "../../../Loader/Loader";
import DatePicker from "react-datepicker";
import soldOutIcon from "../../../../Assets/Images/Revenue-management/soldout.svg";
import ToolsSummaryModal from "../../ToolsSummaryModal";
import DemandScore_High from "../../../../Assets/Images/Revenue-management/DemandScore_High.svg";
import DemandScore_Low from "../../../../Assets/Images/Revenue-management/DemandScore_Low.svg";
import DemandScore_Moderate from "../../../../Assets/Images/Revenue-management/DemandScore_Moderate.svg";
import DemandScore_VeryHigh from "../../../../Assets/Images/Revenue-management/DemandScore_VeryHigh.svg";
import DemandScore_VeryLow from "../../../../Assets/Images/Revenue-management/DemandScore_VeryLow.svg";
import ticket from "../../../../Assets/Images/Revenue-management/tableTicket.svg";
import EventViewModal from "../../../CommonComponent/EventViewModal";
import FlagPopup from "../DailySummary/FlagPopup";
import RNX_SingleDateSummaryModal from "../../RNX_SingleDateSummaryModal";
import darkNoteIcon from "../../../../Assets/Images/CRM/darkNotes.svg";
import NoteIcon from "../../../../Assets/Images/CRM/notes.svg";
import WidgetNote from "../../WidgetNote";
import { FixColumn } from "../../../../utils/dataTable";
import { errorToastMessage } from "../../../../utils/toastMessage";
import CustomRangePicker from "../../../CommonComponent/CustomRangePIcker";
const RNXisell = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {
    const userDetail = commonService.getLoginUserData();

    let date = new Date();
    const startRangeDateRef = useRef();
    const endRangeDateRef = useRef();
    const eventListRef = useRef();
    const selectedEventDateRef = useRef();
    const eventListPropsRef = useRef();
    const clickedDateForNote = useRef();
    const [showNoteSidebar, setShowNoteSidebar] = useState(false);
    const closeNoteSideBar = () => {
        setShowNoteSidebar(false);
    };

    const [showToolsSummaryModal, setToolsSummaryModal] = useState(false);
    const [showTicketModal, setShowTicketModal] = useState(false);

    const [NumberOfDays, setNumberOfDays] = useState(30);

    const currentMonthFirstDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);

    let [startRangeDate, setStartRangeDate] = useState(currentMonthFirstDate);
    let [endRangeDate, setEndRangeDate] = useState(() => {
        const today = new Date();
        const futureDate = new Date(today);
        futureDate.setDate(today.getDate() + NumberOfDays);
        return futureDate;
    });

    const htmlToText = (html) => {
        const tempElement = document.createElement("div");
        tempElement.innerHTML = html;
        const plainText = tempElement.innerText;
        return plainText;
    };

    const startDateArrayRef = useRef([]);
    const [ClickedDate, setClickedDate] = useState(new Date());
    const pickupdate = new Date(commonService.getDateInFormat(para?.asOfDate));
    const [loading, setLoading] = useState(false);
    const maxDateRef = useRef();
    const sevenMaxDateRef = useRef();
    const [dataLoading, setDataLoading] = useState(false);
    const [activePresetRange, setActivePresetRange] = useState(null);
    const [openDatePicker, setOpenDatePicker] = useState(false);
    const widgetDetailRef = useRef();
    const [widgetModal, setWidgetModal] = useState(false);
    const { snapshottitle, propertyCode, snapshotId } = useParams();
    const [chennalName, setChennalName] = useState([]);
    const [onTheBook, setOnTheBook] = useState([]);

    const [otbPickup, setOtbPickup] = useState([]);
    const [otbPickup7Days, setOtbPickup7Days] = useState([]);

    const [rateShopListData, setRateShopListData] = useState([]);
    const [marketTrendsData, setMarketTrendsData] = useState([]);
    const [past_rateShopListData, setPast_rateShopListData] = useState([]);
    const [selectPickupDate, setSelectPickupDate] = useState(
        new Date(pickupdate.getTime() - 1 * 24 * 60 * 60 * 1000)
    );
    const [selectSevenDayPickupDate, setSelectSevenDayPickupDate] = useState(
        new Date(pickupdate.getTime() - 7 * 24 * 60 * 60 * 1000)
    );
    const singleDatePickupDateRef = useRef();
    const [maxDateForPickupFrom, setMaxDateForPickupFrom] = useState();
    if (maxDateForPickupFrom) {
        let date = new Date(maxDateForPickupFrom);
        let sevenDate = new Date(maxDateForPickupFrom);
        maxDateRef.current = date.setDate(date.getDate() - 1);
        sevenMaxDateRef.current = sevenDate.setDate(sevenDate.getDate() - 7);
    }
    const closeWidgetModal = () => {
        setWidgetModal(false);
    };

    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail
    );

    const defaultAsOfDateFromRTK = useSelector(
        (store) => store.headerProperty.defaultAsOfDate
    );

    const [forecastData, setForecastData] = useState(null);
    const [forecastLoading, setForecastLoading] = useState(null);

    const [selectedForecast, setSelectedForecast] = useState(propertyDetailFromRTK?.revenuconfig[0]?.forcasttype_term ? propertyDetailFromRTK?.revenuconfig[0]?.forcasttype_term.toLowerCase() : "ema");
    const [ShowHNF, setShowHNF] = useState(propertyDetailFromRTK?.revenuconfig[0]?.cm_hnf ? propertyDetailFromRTK?.revenuconfig[0]?.cm_hnf : false);
    const [ShowRateOnCM, setShowRateOnCM] = useState(propertyDetailFromRTK?.revenuconfig[0]?.cm_rateoncm ? propertyDetailFromRTK?.revenuconfig[0]?.cm_rateoncm : false);
    const resolveRangeStart = () =>
        startRangeDateRef.current
            ? commonService.getDateInDBFormat(startRangeDateRef.current)
            : commonService.getDateInDBFormat(startRangeDate);
    const resolveRangeEnd = () =>
        endRangeDateRef.current
            ? commonService.getDateInDBFormat(endRangeDateRef.current)
            : commonService.getDateInDBFormat(endRangeDate);
    const resolveRangeStartDate = () =>
        startRangeDateRef.current ? new Date(startRangeDateRef.current) : new Date(startRangeDate);

    const handleDateChange = (event) => {
        const [start, end] = event;
        let startSelectedDate = "",
            endSelectedDate = "";
        if (start) {
            let date = new Date(start);
            let month =
                date.getMonth() + 1 > 9
                    ? date.getMonth() + 1
                    : `0${date.getMonth() + 1}`;
            let dateFormat =
                date?.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
            startSelectedDate = `${date.getFullYear()}-${month}-${dateFormat}`;
            startRangeDateRef.current = startSelectedDate;
        }
        if (end) {
            let date = new Date(end);
            let month =
                date.getMonth() + 1 > 9
                    ? date.getMonth() + 1
                    : `0${date.getMonth() + 1}`;
            let dateFormat =
                date?.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
            endSelectedDate = `${date.getFullYear()}-${month}-${dateFormat}`;
            endRangeDateRef.current = endSelectedDate;
        }

        setStartRangeDate(event[0]);
        setEndRangeDate(event[1]);
        setActivePresetRange(null);
        if (event[0] !== null && event[1] !== null) {
            // let datesArr = commonService.getDateBetweenTwoDates(event[0], event[1]);
            // startDateArrayRef.current = datesArr;
            // callBothApi();
        }
    };

    const handleApplyRange = (start, end) => {
        if (!start || !end) return;

        // 🔥 Convert to timezone
        const tzStart = commonService.convertDateInTimezone(start);
        const tzEnd = commonService.convertDateInTimezone(end);

        // 🔥 Normalize to DB format
        const normalizedStart =
            commonService.getDateInDBFormat(tzStart);

        const normalizedEnd =
            commonService.getDateInDBFormat(tzEnd);

        // 🔥 Store in refs
        startRangeDateRef.current = normalizedStart;
        endRangeDateRef.current = normalizedEnd;

        if (
            startRangeDateRef.current &&
            endRangeDateRef.current
        ) {
            const datesArr =
                commonService.getDateBetweenTwoDates(
                    commonService.convertDateInTimezone(
                        startRangeDateRef.current
                    ),
                    commonService.convertDateInTimezone(
                        endRangeDateRef.current
                    )
                );
            startDateArrayRef.current = datesArr;
            GetAllData();
        }
    };

    function getNext30Days() {
        const dates = [];
        const today = new Date();

        for (let i = 0; i < 30; i++) {
            const nextDate = new Date(today);
            nextDate.setDate(today.getDate() + i);

            // Format as YYYY-MM-DD (you can change to your need)
            const formatted = nextDate.toISOString().split("T")[0];
            dates.push(formatted);
        }
        return dates;
    }

    const [tblids, settblids] = useState({
        rnxtbl1: commonService.GenerateGUID(),
    });


    const getNoteByDataList = async () => {
        let noteByDataListResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.Configuration +
                    API_URL.WIDGET_NOTE.GET_BY_DATA_LIST,
                body: {
                    propertyid: propertyDetailFromRTK?.propertyid,
                    widgetid: 0,
                    startdate: resolveRangeStart(),
                    enddate: resolveRangeEnd(),
                },
            },
            false
        );

        let response = apiResponse(false, noteByDataListResponse);

        if (response?.isValidate) {
            setNoteDetail(response?.data?.data);
        }

        if (!response?.isValidate) {
            setNoteDetail(null);
        }
    };

    const getForecastDetail = async () => {
        setForecastLoading(true);
        let forecastResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.DAILY_SUMMARY.PRICING_FORECAST,
                body: {
                    AsOfDate: para?.asOfDate,
                    startDate: resolveRangeStart(),
                    endDate: resolveRangeEnd(),
                    propertyCode: para?.propertyCode,
                    propertyid: para?.propertyDetail?.propertyid,
                    ForcastType: (selectedForecast ? selectedForecast : "ema").toLowerCase(),
                },
            },
            false
        );

        let response = apiResponse(false, forecastResponse);

        if (response?.isValidate) {
            setForecastData(response?.data?.data);
            setForecastLoading(false);
        }

        if (!response?.isValidate) {
            setForecastData([]);
            setForecastLoading(false);
        }
    };

    const GetTableDataONTHEBOOK = async () => {
        try {
            let TableResponse = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASE_API_URL.SnapShot + API_URL.RNX.RNX_ON_THE_BOOk,
                    body: {
                        asofdate: commonService.getDateInFormat(para?.asOfDate),
                        propertycode: para?.propertyCode,
                        startdate: resolveRangeStart(),
                        enddate: resolveRangeEnd(),
                    },
                },
                false
            );
            let response = apiResponse(false, TableResponse);
            if (response?.isValidate) {
                setOnTheBook(response?.data?.data);
            }
        } catch (error) { }
    };

    const rateShopListAsOfDate = async () => {
        let byPropertyIdResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.RevenueManagement +
                    API_URL.REVENUE_RATE_SHOP_CONFIG.GET_BY_PROPERTY_ID,
                body: {
                    id: para?.propertyDetail?.propertyid,
                },
            },
            false
        );

        let propertyResponse = apiResponse(false, byPropertyIdResponse);

        let CompareDate = new Date(para?.asOfDate);
        CompareDate = CompareDate.setDate(CompareDate.getDate() - 1)

        let rateShopListResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.RATESHOP_LIST,
                body: {
                    AsOfDate: para?.asOfDate,
                    propertyCode: para?.propertyCode,
                    Channel: propertyResponse?.data?.data?.channel_term
                        ? propertyResponse?.data?.data?.channel_term
                        : "",
                    startDate: resolveRangeStart(),
                    endDate: resolveRangeEnd(),
                    propertyid: para?.propertyDetail?.propertyid,
                    CompareDate: CompareDate ? commonService.getDateInDBFormat(CompareDate) : "",
                },
            },
            false
        );

        let response = apiResponse(false, rateShopListResponse);
        if (response?.isValidate) {
            const baseDateForTd = resolveRangeStartDate();
            let rateShopData = response?.data?.data?.map((item, index) => {
                let dateForTd = new Date(baseDateForTd);
                item.date = commonService.getDateInDBFormat(
                    dateForTd.setDate(dateForTd.getDate() + index)
                );
                return item;
            });
            setRateShopListData(rateShopData);
        }

        if (!response?.isValidate) {
            setRateShopListData(null);
        }
    };

    const past_rateShopListAsOfDate = async () => {
        let byPropertyIdResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.RevenueManagement +
                    API_URL.REVENUE_RATE_SHOP_CONFIG.GET_BY_PROPERTY_ID,
                body: {
                    id: para?.propertyDetail?.propertyid,
                },
            },
            false
        );

        let propertyResponse = apiResponse(false, byPropertyIdResponse);

        let PevAsOfDate = new Date(para?.asOfDate);
        PevAsOfDate = new Date(date.setDate(PevAsOfDate.getDate() - 1));

        let rateShopListResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.PAST_RATESHOP_LIST,
                body: {
                    AsOfDate: commonService.getDateForNode(PevAsOfDate),
                    propertyCode: para?.propertyCode,
                    Channel: propertyResponse?.data?.data?.channel_term
                        ? propertyResponse?.data?.data?.channel_term
                        : "",
                    startDate: resolveRangeStart(),
                    endDate: resolveRangeEnd(),
                    propertyid: para?.propertyDetail?.propertyid,
                },
            },
            false
        );

        let response = apiResponse(false, rateShopListResponse);
        if (response?.isValidate) {
            const baseDateForTd = resolveRangeStartDate();
            let rateShopData = response?.data?.data?.map((item, index) => {
                let dateForTd = new Date(baseDateForTd);
                item.date = commonService.getDateInDBFormat(
                    dateForTd.setDate(dateForTd.getDate() + index)
                );
                return item;
            });
            setPast_rateShopListData(rateShopData);
        }

        if (!response?.isValidate) {
            setPast_rateShopListData([]);
        }
    };

    const [FLAG_MECHANISM, setFLAG_MECHANISM] = useState([]);

    const [flagModal, setFlagModal] = useState(false);
    const [flagModalData, setFlagModalData] = useState({});

    const getFLAG_MECHANISM = async () => {
        let List = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.FLAG_MECHANISM,
                body: {
                    asofdate: para?.asOfDate,
                    startdate: resolveRangeStart(),
                    enddate: resolveRangeEnd(),
                    propertyCode: para?.propertyCode,
                },
            },
            false
        );

        let Response = apiResponse(false, List);

        if (Response?.isValidate) {
            setFLAG_MECHANISM(Response.data.data);
        }

        if (!Response?.isValidate) {
        }
    };

    const GetTableDataOTBPICKUPONEDAY = async (params, year) => {
        try {
            let TableResponse = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASE_API_URL.SnapShot + API_URL.RNX.RNX_OTB_PICKUP,
                    body: {
                        asofdate: commonService.getDateInFormat(para?.asOfDate),
                        propertycode: para?.propertyCode,
                        startdate: resolveRangeStart(),
                        enddate: resolveRangeEnd(),
                        pickupdate: commonService.getDateInFormat(selectPickupDate),
                    },
                },
                false
            );
            let response = apiResponse(false, TableResponse);
            if (response?.isValidate) {
                setOtbPickup(response?.data?.data);
            }
        } catch (error) { }
    };

    const GetTableDataOTBPICKUPSEVENDAY = async (params, year) => {
        try {
            let TableResponse = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASE_API_URL.SnapShot + API_URL.RNX.RNX_OTB_PICKUP,
                    body: {
                        asofdate: commonService.getDateInFormat(para?.asOfDate),
                        propertycode: para?.propertyCode,
                        startdate: resolveRangeStart(),
                        enddate: resolveRangeEnd(),
                        pickupdate: commonService.getDateInFormat(selectSevenDayPickupDate),
                    },
                },
                false
            );
            let response = apiResponse(false, TableResponse);
            if (response?.isValidate) {
                setOtbPickup7Days(response?.data?.data);
            }
        } catch (error) { }
    };



    const GetTableDataMarketTrends = async () => {
        try {
            let TableResponse = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.SnapShot + API_URL.RNX.RNX_OTB_MARKET_TRENDS,
                    body: {
                        asofdate: commonService.getDateInFormat(para?.asOfDate),
                        propertycode: para?.propertyCode,
                        startdate: resolveRangeStart(),
                        enddate: resolveRangeEnd(),
                    },
                },
                false
            );
            let response = apiResponse(false, TableResponse);
            if (response?.isValidate) {
                setMarketTrendsData(response?.data?.data);
            }
        } catch (error) { }
    };
    const renderTooltip = (message, item) => (
        <Popover id="popover-id" className="tooltip-flag">
            <div className="m-2">{message}</div>
            <div className="d-flex justify-content-center mb-2">
                <Button id={commonService.generateGlobalClickTrackerID("RNXisell", "ask-rm-copilot", item)}
                    onClick={() => {
                        setFlagModal(true);
                        setFlagModalData({
                            asofdate: para?.asOfDate,
                            dates: item,
                            propertycode: para?.propertyCode,
                        });
                    }}
                >
                    Ask RM Copilot
                </Button>
            </div>
        </Popover>
    );

    const getEventList = async () => {
        let eventList = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.RevenueManagement + API_URL.EVENTS.GET_LIST,
                body: {
                    pageNum: 1,
                    pageSize: 10,
                    sortColumn: "",
                    sortDirection: "asc",
                    searchValue: "",
                    propertyid: parseInt(para?.propertyDetail?.propertyid),
                    startdate: null,
                    enddate: null,
                    eventname: "",
                    eventtypeterm: "",
                    yearterm: ``,
                },
            },
            false
        );

        let eventListResponse = apiResponse(false, eventList);

        if (eventListResponse?.isValidate) {
            let eventListArr = [];

            eventListResponse?.data?.data?.forEach((item) => {
                try {
                    let singleEventObj = {
                        id: item?.eventid ? item?.eventid : 0,
                        name: item?.eventname,
                        detail: item?.eventdetails,
                        startDate: item?.startdate,
                        endDate: item?.enddate,
                        eventJson: item?.eventjson,
                        eventResourceId: item?.eventsourceid,
                    };
                    let eventJsonData = "";
                    if (item?.eventjson) {
                        var decodedString = decodeURIComponent(item?.eventjson);
                        const jsonStringWithoutQuotes = decodedString.slice(1, -1);
                        const jsonStringWithSingleQuotes = `${jsonStringWithoutQuotes}`;
                        eventJsonData = JSON.parse(jsonStringWithSingleQuotes);
                        let desc = eventJsonData?.description?.replaceAll("+", " ");
                        singleEventObj = {
                            ...singleEventObj,
                            labels: eventJsonData?.labels ? eventJsonData?.labels : "",
                            rank: eventJsonData?.rank ? eventJsonData?.rank : 0,
                            local_rank: eventJsonData?.local_rank
                                ? eventJsonData?.local_rank
                                : 0,
                            phq_attendance: eventJsonData?.phq_attendance
                                ? eventJsonData?.phq_attendance
                                : 0,
                            geo_lat: eventJsonData?.geo_lat ? eventJsonData?.geo_lat : "",
                            geo_long: eventJsonData?.geo_long ? eventJsonData?.geo_long : "",
                            detail: desc,
                        };
                    }
                    eventListArr.push(singleEventObj);
                } catch (err) { }
            });
            eventListRef.current = eventListArr;
        }

        if (!eventListResponse?.isValidate) {
            eventListRef.current = [];
        }
    };

    const GetAllData = async () => {
        setDataLoading(true);
        await getFLAG_MECHANISM();
        await GetTableDataONTHEBOOK();
        await GetTableDataOTBPICKUPONEDAY();
        await GetTableDataOTBPICKUPSEVENDAY();
        await getForecastDetail();
        await rateShopListAsOfDate();
        await past_rateShopListAsOfDate();
        await GetTableDataMarketTrends();
        await getEventList();
        await getNoteByDataList();
        setDataLoading(false);
    };

    useEffect(() => {
        if (api === 0) {
        } else {
            if (para?.asOfDate) {
                GetAllData();
            }
        }
    }, [para?.asOfDate, selectSevenDayPickupDate, selectPickupDate, NumberOfDays, selectedForecast]);

    const selectedTdIndexRef = useRef();
    const singleDateSelectedDateRef = useRef();
    const [ONTHEBOOKS, setONTHEBOOKS] = useState({
        IsDisplay: false,
        // Property: { top: 0, left: 0 },
        Target: null,
        Position: "top",
    });
    const handleFilterBtnClick = (event) => {
        // let screenY = event.screenY;
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        // let Left = event.nativeEvent.layerX + 30;
        if (Top + 400 > window.innerHeight) {
            // Top = Top - 400;
            Position = "top";
        }
        setONTHEBOOKS({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };

    const closeSingleDate = () => {
        selectedTdIndexRef.current = -1;
        // setONTHEBOOKS({ IsDisplay: false, Property: { top: 0, left: 0 } });
        setONTHEBOOKS({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
    };

    function fnNumberOfDaysAreChange(val) {
        let s = currentMonthFirstDate // new Date();
        setStartRangeDate(currentMonthFirstDate);

        // const today = new Date();
        const today = currentMonthFirstDate
        const futureDate = new Date(today);
        futureDate.setDate(today.getDate() + val);

        setEndRangeDate(futureDate);
        startRangeDateRef.current = commonService.getDateInDBFormat(commonService.convertDateInTimezone(s));
        endRangeDateRef.current = commonService.getDateInDBFormat(commonService.convertDateInTimezone(futureDate));
        setNumberOfDays(val);
    }


    const [noteDetail, setNoteDetail] = useState(null);

    FixColumn(tblids.rnxtbl1, [1]);


    commonService.setBackColorPerByTDValue(
        "#638EC6",
        "Red",
        `#${tblids.rnxtbl1} .perbackground-otb`
    );

    commonService.setBackColorPerByTDValue(
        "Green",
        "Red",
        `#${tblids.rnxtbl1} .perbackground-adr`
    );

    commonService.setBackColorPerByTDValue(
        "#638EC6",
        "Red",
        `#${tblids.rnxtbl1} .perbackground-room`
    );
    let dayName = false;

    const handleExport = async (type) => {
        let tableId = document.querySelector(".rnxisell").cloneNode(true);

        if (tableId.querySelector(".loding-animation")) {
            errorToastMessage("Wait for the data loading.");
            return;
        }

        let HNFFlag = tableId.getAttribute("isshowrnx");
        let RATEONCMFlag = tableId.getAttribute("isshowrateoncm");


        tableId.querySelectorAll("input, select").forEach(el => {
            el.remove();
        });

        let groupingJson = {
            data: [],
            // filename: `${para?.propertyCode}-iSell-${moment(new Date()).format(
            //     "MMDDYYYY"
            // )}`,
            filename: `${para?.propertyDetail?.propertyname}-Pickup_and_Revenue_Report-${moment(para?.asOfDate).format(
                "MMDDYYYY"
            )}`,
        };

        let groupingTable = [
            {
                widgetname: "iSell",
                rowdata: [],
            },
        ];


        groupingTable[0].rowdata.push({
            data: ["iSell"],
        });
        groupingTable[0].rowdata.push({
            data: [],
        });



        const findTblHeader = tableId?.querySelectorAll("thead tr");
        const findTblTbody = tableId?.querySelectorAll("tbody tr");

        findTblHeader.forEach((tblHeaderItem, tblHeaderIndex) => {
            let allTh = tblHeaderItem.querySelectorAll("th");
            let allThValue = [];

            allTh.forEach((thItem, thIndex) => {
                let thText = thItem?.textContent;
                allThValue.push(thText ? thText : "");
            });

            groupingTable[0].rowdata.push({ data: allThValue });
            if (tblHeaderIndex === 0) {
                groupingTable[0].rowdata.push({
                    data: [],
                });
            }
        });

        findTblTbody.forEach((tblHeaderItem, tblHeaderIndex) => {
            let allTh = tblHeaderItem.querySelectorAll("td");
            let allThValue = [];

            allTh.forEach((thItem, thIndex) => {
                let thText = thItem?.textContent;
                allThValue.push(thText ? thText : "");
            });

            groupingTable[0].rowdata.push({ data: allThValue });
        });


        groupingJson.data = [...groupingJson.data, ...groupingTable];
        groupingJson = {
            ...groupingJson,
            snapshotid: snapshotId ? parseInt(snapshotId) : 0,
            sendtoemails: userDetail?.email ? userDetail?.email : "",
            actiontype: type,
            asofdata: para?.asOfDate
                ? commonService.getDateInDBFormat(para?.asOfDate)
                : "",
            hnf_flag: HNFFlag ? HNFFlag : "no",
            rateoncm_flag: RATEONCMFlag ? RATEONCMFlag : "no",
        };
        await commonService.widgetWiseExportExcel(groupingJson);
    };

    const safeDivide = (a, b) => (b ? a / b : 0);

    return (

        <div className="widget-container" style={{ position: "relative" }}>
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">
                    <Button
                        className="heading-menu-btns"
                        type="button"
                        title="Send Mail"
                    >
                        <img id={commonService.generateGlobalClickTrackerID("RNXisell", "emailicon", propertyCode)}
                            src={emailIcon}
                            alt="emailIcon"
                            onClick={() => {
                                if (
                                    window.location.href.includes("iSell")
                                ) {
                                    handleExport("EMAIL");
                                } else {
                                    commonService.fnSendWidgetMail(
                                        tblids.rnxtbl1,
                                        "iSell",
                                        snapshotId,
                                        defaultAsOfDateFromRTK,
                                        "",
                                        para?.widgetId
                                    );
                                }
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("RNXisell", "info", propertyCode)}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.RNXAnalysis1,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("RNXisell", "menuicon", propertyCode)}
                            src={downloadIcon}
                            alt="menuIcon"
                            import={tblids.rnxtbl1}
                            onClick={() => {
                                if (
                                    window.location.href.includes("iSell")
                                ) {
                                    handleExport("DOWNLOAD");
                                } else {
                                    commonService.fnExportInCSV(
                                        tblids.rnxtbl1,
                                        // `${para?.propertyCode}-iSell-${moment(
                                        //     new Date()
                                        // ).format("MMDDYYYY")}`
                                        `${para?.propertyDetail?.propertyname}-Pickup_and_Revenue_Report-${moment(para?.asOfDate).format(
                                            "MMDDYYYY"
                                        )}`
                                    );
                                }
                            }}
                        />
                    </Button>
                </div>
            )}
            <div className="ViewPropertySetupTable mainTableClass">
                <div className="stripped__table">
                    <div className="table-responsive tblDynamicPickupSticky">
                        <Table id={tblids.rnxtbl1} className="table-with-spacing positionStaticTable rnxisell" isshowrnx={ShowHNF ? "yes" : "no"} isshowrateoncm={ShowRateOnCM ? "yes" : "no"} >
                            <thead className="tbl-header-sticky">
                                <tr className="diff-bg-tr table-main-header-tr">
                                    <th className="width150">
                                        <select id={commonService.generateGlobalClickTrackerID("RNXisell", "notes", propertyCode)} class="form-select" value={NumberOfDays} onChange={(e) => fnNumberOfDaysAreChange(parseInt(e.target.value))}>
                                            <option value="30">30 Days</option>
                                            <option value="60">60 Days</option>
                                            <option value="90">90 Days</option>
                                            <option value="180">180 Days</option>
                                        </select>

                                        {NumberOfDays && (
                                            <span
                                                style={{ display: "none" }}
                                            >{NumberOfDays} Days</span>
                                        )}


                                    </th>

                                    <th className="border-right text-center" colSpan={8}>
                                        On The Book
                                    </th>
                                    {
                                        ShowHNF &&
                                        <th className="border-right text-center" colSpan={3}>
                                            HNF
                                        </th>
                                    }

                                    <th className="border-right text-center" colSpan={3}>
                                        {api !== 0 ? (
                                            <div className="">
                                                <span>1 Day Pickup</span>
                                                <br />
                                                <DatePicker
                                                    portalId="datepicker-root"
                                                    className=""
                                                    id="pickupDate"
                                                    maxDate={new Date(maxDateRef.current)}
                                                    selected={selectPickupDate}
                                                    value={selectPickupDate}
                                                    onChange={(date) => {
                                                        singleDatePickupDateRef.current =
                                                            commonService.getDateInFormat(date);
                                                        setSelectPickupDate(date);
                                                    }}
                                                    wrapperClassName="width110"
                                                /> {" "}
                                                <span style={{ display: "none" }}>
                                                    {selectPickupDate
                                                        ? commonService.getDateInFormat(
                                                            new Date(selectPickupDate)
                                                        )
                                                        : commonService.getDateInFormat(
                                                            new Date(maxDateRef.current)
                                                        )}
                                                </span>
                                            </div>
                                        ) : (
                                            <div>1 Day Pickup</div>
                                        )}
                                    </th>
                                    <th className="border-right text-center" colSpan={3}>
                                        {api !== 0 ? (
                                            <div className="">
                                                <span>Pickup Since</span>
                                                <br />
                                                <DatePicker
                                                    portalId="datepicker-root"
                                                    className=""
                                                    id="pickupDate"
                                                    maxDate={new Date(maxDateRef.current)}
                                                    selected={selectSevenDayPickupDate}
                                                    value={selectSevenDayPickupDate}
                                                    onChange={(date) => {
                                                        singleDatePickupDateRef.current =
                                                            commonService.getDateInFormat(date);
                                                        setSelectSevenDayPickupDate(date);
                                                    }}
                                                    wrapperClassName="width110"
                                                />
                                                {" "}
                                                <span style={{ display: "none" }}>
                                                    {selectSevenDayPickupDate
                                                        ? commonService.getDateInFormat(
                                                            new Date(selectSevenDayPickupDate)
                                                        )
                                                        : commonService.getDateInFormat(
                                                            new Date(maxDateRef.current)
                                                        )}
                                                </span>
                                            </div>
                                        ) : (
                                            <div>7 Day Pickup</div>
                                        )}
                                    </th>
                                    <th className="text-center border-right" colSpan={3}>
                                        Pricing & Forecast
                                    </th>
                                    {api !== 0 && rateShopListData && !dataLoading && (
                                        <th
                                            colSpan={
                                                rateShopListData?.filter(
                                                    (x) =>
                                                        x.CheckInDate ===
                                                        moment(
                                                            rateShopListData?.[0]?.CheckInDate
                                                        ).format("YYYY-MM-DD")
                                                )?.length * 2 + (ShowRateOnCM ? 6 : 5)
                                            }
                                            className="border-right text-center"
                                        >
                                            RateShop
                                        </th>
                                    )}
                                    {/*<th className="border-right text-center"></th>*/}
                                </tr>
                                <tr className="table-main-header-tr">
                                    {api !== 0 ? (
                                        <th id={commonService.generateGlobalClickTrackerID("RNXisell", "date-cancel-apply", propertyCode)}
                                            className="width150 text-center"
                                            onClick={() => {
                                                setOpenDatePicker(true);
                                            }}
                                        >
                                            Date <br />
                                            <DatePicker id={commonService.generateGlobalClickTrackerID("RNXisell", "datepicker-onchange", propertyCode)}
                                                portalId="datepicker-root"
                                                onChange={(event) => handleDateChange(event)}
                                                startDate={startRangeDate}
                                                endDate={endRangeDate}
                                                selectsRange
                                                monthsShown={2}
                                                open={openDatePicker}
                                                shouldCloseOnSelect={false}
                                                dateFormat="dd MMM"
                                                wrapperClassName="width110"
                                            >
                                                <div
                                                    className="w-100"
                                                    style={{ display: "inline-block" }}
                                                >
                                                    <CustomRangePicker id={commonService.generateGlobalClickTrackerID("RNXisell", "customrangepicker-onchange", propertyCode)}
                                                        activePreset={activePresetRange}
                                                        setActivePreset={setActivePresetRange}
                                                        setOpenDatePicker={setOpenDatePicker}
                                                        onChange={(start, end, type) => {
                                                            setStartRangeDate(start);
                                                            setEndRangeDate(end);
                                                            handleApplyRange(start, end);
                                                        }}
                                                    />
                                                    <div className="content-inside-calendar">
                                                        <p>
                                                            {startRangeDate
                                                                ? commonService.getDateInFormat(
                                                                    startRangeDate
                                                                )
                                                                : ""}
                                                            {startRangeDate && endRangeDate
                                                                ? " - "
                                                                : ""}
                                                            {endRangeDate
                                                                ? commonService.getDateInFormat(
                                                                    endRangeDate
                                                                )
                                                                : ""}
                                                        </p>
                                                        <div className="d-flex align-items-center gap-2">
                                                            <button id={commonService.generateGlobalClickTrackerID("RNXisell", "cancel", propertyCode)}
                                                                className="secondary-btn"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setStartRangeDate(null);
                                                                    setEndRangeDate(null);
                                                                    startRangeDateRef.current = null;
                                                                    endRangeDateRef.current = null;
                                                                    setOpenDatePicker(false);
                                                                    setActivePresetRange(null);
                                                                }}
                                                            >
                                                                Cancel
                                                            </button>
                                                            <button id={commonService.generateGlobalClickTrackerID("RNXisell", "apply", propertyCode)}
                                                                disabled={
                                                                    startRangeDate && endRangeDate
                                                                        ? false
                                                                        : true
                                                                }
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    if (startRangeDate && endRangeDate) {
                                                                        handleApplyRange(startRangeDate, endRangeDate);
                                                                    }

                                                                    setOpenDatePicker(false);
                                                                    setActivePresetRange(null);
                                                                }}
                                                                className="primary-btn"
                                                            >
                                                                Apply
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </DatePicker>
                                            {startRangeDate && endRangeDate && (
                                                <span
                                                    style={{ display: "none" }}
                                                >{`${commonService.getDateInFormat(
                                                    startRangeDate
                                                )} - ${commonService.getDateInFormat(
                                                    endRangeDate
                                                )}`}</span>
                                            )}
                                        </th>
                                    ) : (
                                        <th className="width175 ">Date</th>
                                    )}
                                    {/*<th className="border-right text-center">DOW</th>*/}
                                    {/*<th className="border-right text-center width175">*/}
                                    {/*    Event*/}
                                    {/*</th>*/}
                                    <th className="border-right text-center">Notes</th>
                                    <th className="border-right text-center">Capacity</th>
                                    <th className=" text-center">
                                        Rooms Avail To Sell Online
                                    </th>
                                    <th className=" text-center">
                                        {propertyDetailFromRTK?.revenuconfig[0]?.cm_flowthrough}
                                    </th>
                                    <th className=" text-center">
                                        Inventory Open%
                                    </th>
                                    <th className=" text-center width75 ">OTA Sold</th>
                                    <th className=" text-center">
                                        OTA Revenue
                                    </th>
                                    <th className=" text-center">OTA ADR</th>

                                    {
                                        ShowHNF &&
                                        <>
                                            <th className="border-right text-center">Hotel Sold</th>
                                            <th className="text-center">Revenue</th>
                                            <th className=" text-center">Hotel Availability</th>
                                        </>
                                    }
                                    <th className="border-right text-center">Pickup</th>
                                    <th className="text-center">
                                        Revenue Pickup
                                    </th>

                                    <th className=" text-center">
                                        ADR Pickup
                                    </th>
                                    <th className="border-right text-center">Pickup</th>
                                    <th className=" text-center">
                                        Revenue Pickup
                                    </th>
                                    <th className=" text-center">
                                        ADR Pickup
                                    </th>
                                    <th className="text-center border-right width110">
                                        <div>
                                            <Form.Select id={commonService.generateGlobalClickTrackerID("RNXisell", "system-forecast", propertyCode)}
                                                value={selectedForecast}
                                                onChange={(e) => {
                                                    setSelectedForecast(e.target.value);
                                                }}
                                            >
                                                <option value="ema">System Forecast</option>
                                                <option value="rms">RMS Forecast</option>
                                                {/*<option value="user">USER Forecast</option>*/}
                                                <option value="nova">RM Copilot Forecast</option>
                                            </Form.Select>
                                            <span style={{ display: "none" }}>
                                                {commonService.ForecastTypeDisplayLable(selectedForecast)}
                                            </span>
                                        </div>
                                    </th>
                                    <th>R28 Avg</th>
                                    <th className="text-end">Recommended Rate</th>
                                    <th className="border-right text-center">
                                        Market Trend
                                    </th>
                                    <th className="border-right text-center width70">
                                        7D COMP AVG
                                    </th>
                                    <th className="border-right text-center width70">
                                        7D COMP AVG DIFF
                                    </th>
                                    {
                                        ShowRateOnCM &&
                                        <th className="border-right text-center">
                                            Rate on CM
                                        </th>
                                    }

                                    {api !== 0 &&
                                        rateShopListData &&
                                        !dataLoading &&
                                        rateShopListData?.map((x) => {
                                            if (
                                                x.CheckInDate ===
                                                moment(
                                                    rateShopListData?.[0]?.CheckInDate
                                                ).format("YYYY-MM-DD") &&
                                                x.IsSelf === true
                                            ) {
                                                return (
                                                    <th
                                                        className="text-end border-right"
                                                        title={x?.competiterpropertyname}
                                                        colSpan={2}
                                                    >
                                                        {x?.competiterpropertyname?.length > 10
                                                            ? `${x?.competiterpropertyname?.slice(
                                                                0,
                                                                10
                                                            )}...`
                                                            : x?.competiterpropertyname}
                                                    </th>
                                                );
                                            }
                                        })}
                                    {api !== 0 && rateShopListData && !dataLoading && (
                                        <>
                                            <th className="text-end border-right" colSpan={2}>
                                                Comp Set Avg
                                            </th>
                                        </>
                                    )}
                                    {api !== 0 &&
                                        rateShopListData &&
                                        rateShopListData?.map((x) => {
                                            if (
                                                x.CheckInDate ===
                                                moment(
                                                    rateShopListData?.[0]?.CheckInDate
                                                ).format("YYYY-MM-DD") &&
                                                x.IsSelf === false
                                            ) {
                                                return (
                                                    <th
                                                        className="text-end"
                                                        title={x?.competiterpropertyname}
                                                        colSpan={2}
                                                    >
                                                        {x?.competiterpropertyname?.length > 10
                                                            ? `${x?.competiterpropertyname?.slice(
                                                                0,
                                                                10
                                                            )}...`
                                                            : x?.competiterpropertyname}
                                                    </th>
                                                );
                                            }
                                        })}
                                    {/* <th className="border-right text-center">Notes</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {api === 0 ? (
                                    <>
                                        {getNext30Days()?.map((item) => {
                                            return (
                                                <>
                                                    <tr>
                                                        <td className="text-center">
                                                            {commonService.getDateInFormat(item)}
                                                        </td>
                                                        <td className="border-right text-center">
                                                            {0}
                                                        </td>
                                                        <td className="border-right text-center">
                                                            {0}
                                                        </td>
                                                        <td className="border-right text-center">
                                                            {0}
                                                        </td>
                                                        <td className="border-right text-center">
                                                            {0}
                                                        </td>
                                                        <td className="border-right text-center">
                                                            {0}
                                                        </td>
                                                        <td className="border-right text-center">
                                                            {0}
                                                        </td>
                                                        <td className="border-right text-center">
                                                            {0}
                                                        </td>
                                                        <td className="border-right text-center">
                                                            {0}%
                                                        </td>
                                                        <td className="border-right text-center">
                                                            {0}
                                                        </td>
                                                        <td className="border-right text-end">
                                                            {commonService.formateAmount(0)}
                                                        </td>
                                                        <td className="border-right text-end">
                                                            {commonService.formateAmount(0)}
                                                        </td>
                                                        <td className="border-right text-center">
                                                            {0}
                                                        </td>
                                                        <td className="border-right text-center">
                                                            {0}
                                                        </td>
                                                        <td className="border-right text-center">
                                                            {0}
                                                        </td>
                                                        <td className="border-right text-center">
                                                            {0}
                                                        </td>
                                                        <td className="border-right text-center">
                                                            {0}
                                                        </td>
                                                        <td className="border-right text-center">
                                                            {0}
                                                        </td>
                                                        <td className="border-right text-center">
                                                            {0}
                                                        </td>
                                                        <td className="border-right">

                                                        </td>
                                                    </tr>
                                                </>
                                            );
                                        })}
                                    </>
                                ) : (
                                    <>
                                        {loading || dataLoading ? (
                                            <tr
                                                style={{ height: "80px", position: "relative" }}
                                            >
                                                <Loader />
                                            </tr>
                                        ) : (
                                            <>
                                                {" "}
                                                {onTheBook?.map((item, index) => {
                                                    dayName = false;
                                                    if (
                                                        moment(new Date(item?.dates), "l").format("ddd") === "Fri" ||
                                                        moment(new Date(item?.dates), "l").format("ddd") === "Sat"
                                                    ) {
                                                        dayName = true;
                                                    }

                                                    const otbPickupMatch = otbPickup?.find(
                                                        (itm1) =>
                                                            commonService?.getDateInFormat(
                                                                itm1?.dates
                                                            ) ===
                                                            commonService?.getDateInFormat(
                                                                item?.dates
                                                            )
                                                    );

                                                    const otbPickup7dayMatch =
                                                        otbPickup7Days?.find(
                                                            (itm1) =>
                                                                commonService?.getDateInFormat(
                                                                    itm1?.dates
                                                                ) ===
                                                                commonService?.getDateInFormat(
                                                                    item?.dates
                                                                )
                                                        );



                                                    let isSelfData = rateShopListData?.filter(
                                                        (x) => {
                                                            if (
                                                                x.CheckInDate ===
                                                                moment(item?.dates).format(
                                                                    "YYYY-MM-DD"
                                                                ) &&
                                                                x.IsSelf === true
                                                            ) {
                                                                return x;
                                                            }
                                                        }
                                                    );

                                                    let SelfDataRateDiff = 0;

                                                    let past_isSelfData = past_rateShopListData?.filter((x) => {
                                                        if (
                                                            x.CheckInDate === moment(item).format("YYYY-MM-DD") &&
                                                            x.IsSelf === true
                                                        ) {
                                                            return x;
                                                        }
                                                    });

                                                    if (past_isSelfData && past_isSelfData.length > 0 && isSelfData && isSelfData.length > 0) {
                                                        let PDRate = past_isSelfData[0]?.Rate ? past_isSelfData[0]?.Rate : 0;
                                                        let Rate = isSelfData[0]?.Rate ? isSelfData[0]?.Rate : 0;
                                                        SelfDataRateDiff = parseInt(PDRate) - parseInt(Rate);
                                                    }

                                                    let rateShoptotal = 0;
                                                    rateShopListData?.map((x) => {
                                                        if (
                                                            x.CheckInDate ===
                                                            moment(item?.dates).format(
                                                                "YYYY-MM-DD"
                                                            ) &&
                                                            x.IsSelf === false
                                                        ) {
                                                            rateShoptotal =
                                                                rateShoptotal + parseFloat(x?.Rate);
                                                        }
                                                    });
                                                    let findCompetitorData =
                                                        rateShopListData?.filter(
                                                            (x) =>
                                                                x.CheckInDate ===
                                                                moment(item?.dates).format(
                                                                    "YYYY-MM-DD"
                                                                ) && x.IsSelf === false
                                                        );

                                                    let past_findCompetitorData = past_rateShopListData?.filter(
                                                        (x) =>
                                                            x.CheckInDate === moment(item).format("YYYY-MM-DD") &&
                                                            x.IsSelf === false
                                                    );


                                                    let findDataForAvgCount =
                                                        rateShopListData?.filter(
                                                            (x) =>
                                                                x.CheckInDate ===
                                                                moment(item?.dates).format(
                                                                    "YYYY-MM-DD"
                                                                ) &&
                                                                x.IsSelf === false &&
                                                                parseFloat(x.Rate) > 0
                                                        );

                                                    let avgCompetitor =
                                                        rateShoptotal > 0 &&
                                                            findDataForAvgCount?.length > 0
                                                            ? Math.round(
                                                                rateShoptotal /
                                                                findDataForAvgCount?.length
                                                            )
                                                            : 0;


                                                    let past_rateShoptotal = 0;

                                                    past_rateShopListData?.map((x) => {
                                                        if (
                                                            x.CheckInDate === moment(item?.dates).format("YYYY-MM-DD") &&
                                                            x.IsSelf === false
                                                        ) {
                                                            past_rateShoptotal = past_rateShoptotal + parseFloat(x?.Rate);
                                                        }
                                                    });

                                                    let past_findDataForAvgCount = past_rateShopListData?.filter(
                                                        (x) =>
                                                            x.CheckInDate === moment(item?.dates).format("YYYY-MM-DD") &&
                                                            x.IsSelf === false &&
                                                            parseFloat(x.Rate) > 0
                                                    );

                                                    let past_avgCompetitor =
                                                        past_rateShoptotal > 0 && past_findDataForAvgCount?.length > 0
                                                            ? Math.round(
                                                                past_rateShoptotal / past_findDataForAvgCount?.length
                                                            )
                                                            : 0;

                                                    let avgCompetitorRateDiff = 0;



                                                    avgCompetitorRateDiff = parseInt(past_avgCompetitor) - parseInt(avgCompetitor);

                                                    let dataExistsOrNot =
                                                        rateShopListData?.filter((x) => {
                                                            if (
                                                                x?.CheckInDate ===
                                                                moment(item?.dates).format(
                                                                    "YYYY-MM-DD"
                                                                ) &&
                                                                x?.IsSelf === false
                                                            ) {
                                                                return x;
                                                            }
                                                        });

                                                    let flagType = null;
                                                    if (
                                                        FLAG_MECHANISM &&
                                                        FLAG_MECHANISM.length > 0
                                                    ) {
                                                        let flagdata = FLAG_MECHANISM.filter(
                                                            (x) =>
                                                                moment(x.dates).format("YYYY-MM-DD") ===
                                                                moment(item?.dates).format("YYYY-MM-DD")
                                                        );
                                                        if (flagdata && flagdata.length > 0) {
                                                            if (flagdata[0]?.demandtag) {
                                                                if (
                                                                    flagdata[0]?.demandtag.toUpperCase().replaceAll(" ", "") ===
                                                                    "HIGH"
                                                                ) {
                                                                    flagType = (
                                                                        <OverlayTrigger
                                                                            placement="right"
                                                                            delay={{ show: 250, hide: 2000 }}
                                                                            overlay={renderTooltip(
                                                                                flagdata[0]?.message,
                                                                                item?.dates
                                                                            )}
                                                                        >
                                                                            <img
                                                                                src={DemandScore_High}
                                                                                alt=""
                                                                                style={{
                                                                                    height: "11px",
                                                                                    width: "11px",
                                                                                }}
                                                                            />
                                                                        </OverlayTrigger>
                                                                    );
                                                                } else if (
                                                                    flagdata[0]?.demandtag.toUpperCase().replaceAll(" ", "") ===
                                                                    "LOW"
                                                                ) {
                                                                    flagType = (
                                                                        <OverlayTrigger
                                                                            placement="right"
                                                                            delay={{ show: 250, hide: 2000 }}
                                                                            message={flagdata[0]?.message}
                                                                            overlay={renderTooltip(
                                                                                flagdata[0]?.message,
                                                                                item?.dates
                                                                            )}
                                                                        >
                                                                            <img
                                                                                src={DemandScore_Low}
                                                                                alt=""
                                                                                style={{
                                                                                    height: "11px",
                                                                                    width: "11px",
                                                                                }}
                                                                            />
                                                                        </OverlayTrigger>
                                                                    );
                                                                } else if (
                                                                    flagdata[0]?.demandtag.toUpperCase().replaceAll(" ", "") ===
                                                                    "MODERATE"
                                                                ) {
                                                                    flagType = (
                                                                        <OverlayTrigger
                                                                            placement="right"
                                                                            delay={{ show: 250, hide: 2000 }}
                                                                            message={flagdata[0]?.message}
                                                                            overlay={renderTooltip(
                                                                                flagdata[0]?.message,
                                                                                item?.dates
                                                                            )}
                                                                        >
                                                                            <img
                                                                                src={DemandScore_Moderate}
                                                                                alt=""
                                                                                style={{
                                                                                    height: "11px",
                                                                                    width: "11px",
                                                                                }}
                                                                            />
                                                                        </OverlayTrigger>
                                                                    );
                                                                } else if (
                                                                    flagdata[0]?.demandtag.toUpperCase().replaceAll(" ", "") ===
                                                                    "VERYHIGH"
                                                                ) {
                                                                    flagType = (
                                                                        <OverlayTrigger
                                                                            placement="right"
                                                                            delay={{ show: 250, hide: 2000 }}
                                                                            message={flagdata[0]?.message}
                                                                            overlay={renderTooltip(
                                                                                flagdata[0]?.message,
                                                                                item?.dates
                                                                            )}
                                                                        >
                                                                            <img
                                                                                src={DemandScore_VeryHigh}
                                                                                alt=""
                                                                                style={{
                                                                                    height: "11px",
                                                                                    width: "11px",
                                                                                }}
                                                                            />
                                                                        </OverlayTrigger>
                                                                    );
                                                                }
                                                                else if (
                                                                    flagdata[0]?.demandtag.toUpperCase().replaceAll(" ", "") ===
                                                                    "VERYLOW"
                                                                ) {
                                                                    flagType = (
                                                                        <OverlayTrigger
                                                                            placement="right"
                                                                            delay={{ show: 250, hide: 2000 }}
                                                                            message={flagdata[0]?.message}
                                                                            overlay={renderTooltip(
                                                                                flagdata[0]?.message,
                                                                                item?.dates
                                                                            )}
                                                                        >
                                                                            <img
                                                                                src={DemandScore_VeryLow}
                                                                                alt=""
                                                                                style={{
                                                                                    height: "11px",
                                                                                    width: "11px",
                                                                                }}
                                                                            />
                                                                        </OverlayTrigger>
                                                                    );
                                                                }
                                                            }
                                                        }
                                                    }

                                                    let checkEvent = eventListRef.current?.filter(
                                                        (x) => {
                                                            let checkingDate = moment(item?.dates);
                                                            let startingDate = moment(x?.startDate);
                                                            let endingDate = moment(x?.endDate);
                                                            if (
                                                                checkingDate.isSameOrAfter(
                                                                    startingDate
                                                                ) &&
                                                                checkingDate.isSameOrBefore(endingDate)
                                                            ) {
                                                                return x;
                                                            }
                                                        }
                                                    );


                                                    let singleForecastData = forecastData?.filter(
                                                        (x) =>
                                                            moment(x.Dates).format("YYYY-MM-DD") ===
                                                            moment(item?.dates).format("YYYY-MM-DD")
                                                    );

                                                    let foreCastSpiderTextColor = "";
                                                    let forecastSpiderBorder = "";
                                                    if (
                                                        singleForecastData?.[0]?.RMS <
                                                        singleForecastData?.[0]?.R28AVG
                                                    ) {
                                                        foreCastSpiderTextColor = "redText";
                                                        let R28AvgPercentage =
                                                            (singleForecastData?.[0]?.R28AVG * 10) / 100;
                                                        let finalValue =
                                                            singleForecastData?.[0]?.R28AVG - R28AvgPercentage;
                                                        if (singleForecastData?.[0]?.RMS < finalValue) {
                                                            forecastSpiderBorder = "redBorderTd";
                                                        }
                                                    } else {
                                                        let R28AvgPercentage =
                                                            (singleForecastData?.[0]?.R28AVG * 10) / 100;
                                                        let finalValue =
                                                            singleForecastData?.[0]?.R28AVG + R28AvgPercentage;
                                                        if (singleForecastData?.[0]?.RMS > finalValue) {
                                                            forecastSpiderBorder = "blackBorderTd";
                                                        }
                                                    }

                                                    let checkNoteExists = noteDetail?.notedata?.filter(
                                                        (x) =>
                                                            moment(x?.datadate).format("YYYY-MM-DD") ===
                                                            moment(item?.dates).format("YYYY-MM-DD")
                                                    );


                                                    return (
                                                        <>
                                                            <tr
                                                                className={`${dayName ? "backgroundTr" : ""
                                                                    } shadowOnHover`}
                                                                key={commonService.getDateInFormat(
                                                                    item?.dates
                                                                )}
                                                            >
                                                                <td className="text-center">
                                                                    <div className="d-flex gap-1">
                                                                        {flagType ? (
                                                                            flagType
                                                                        ) : (
                                                                            <div
                                                                                style={{
                                                                                    height: "11px",
                                                                                    width: "11px",
                                                                                }}
                                                                            >
                                                                                {" "}
                                                                            </div>
                                                                        )}

                                                                        <div className="d-flex gap-4">
                                                                            {commonService.getDateInFormat(
                                                                                item?.dates
                                                                            )} {item.dow}
                                                                            <div className="d-flex justify-content-between align-items-center gap-2 ticketAlarmReload">
                                                                                {checkEvent?.length > 0 && (
                                                                                    <img id={commonService.generateGlobalClickTrackerID("RNXisell", "ticket", item)}
                                                                                        style={{
                                                                                            height: "11px",
                                                                                            width: "11px",
                                                                                        }}
                                                                                        className="iconcolor"
                                                                                        src={ticket}
                                                                                        alt="ticket"
                                                                                        onClick={() => {
                                                                                            selectedEventDateRef.current =
                                                                                                item?.dates;
                                                                                            eventListPropsRef.current =
                                                                                                checkEvent;
                                                                                            setShowTicketModal(true);
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className="border-right">
                                                                    <div>
                                                                        {checkNoteExists?.length > 0 ? (
                                                                            <img id={commonService.generateGlobalClickTrackerID("RNXisell", "note", item)}
                                                                                className="cursorPointer"
                                                                                src={darkNoteIcon}
                                                                                onClick={() => {
                                                                                    clickedDateForNote.current = item.dates;
                                                                                    setShowNoteSidebar(true);
                                                                                }}
                                                                                alt="note"
                                                                            />
                                                                        ) : (
                                                                            <img id={commonService.generateGlobalClickTrackerID("RNXisell", "note", item)}
                                                                                className="cursorPointer"
                                                                                src={NoteIcon}
                                                                                onClick={() => {
                                                                                    clickedDateForNote.current = item.dates;
                                                                                    setShowNoteSidebar(true);
                                                                                }}
                                                                                alt="note"
                                                                            />
                                                                        )}

                                                                        <div style={{ display: "none" }}>
                                                                            {checkNoteExists?.map((item, index) => {
                                                                                return (
                                                                                    <>
                                                                                        <span>{`${item?.displayname
                                                                                            } - ${htmlToText(
                                                                                                item?.widgetnotes
                                                                                            )}`}</span>{" "}
                                                                                        <br />
                                                                                    </>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    </div>
                                                                </td>

                                                                <td className="border-right text-center">
                                                                    {item.inventory}
                                                                </td>
                                                                <td className=" text-center">
                                                                    {item.rooms_availtosell}
                                                                </td>
                                                                <td className=" text-center">
                                                                    {item.superior_room}
                                                                </td>
                                                                <td className=" text-center">
                                                                    {item.inventory_open}%
                                                                </td>
                                                                <td className=" text-primary text-center perbackground perbackground-otb"
                                                                    value={
                                                                        item.ota_sold
                                                                            ? commonService.formateRoom(
                                                                                item.ota_sold
                                                                            )
                                                                            : 0
                                                                    }
                                                                >
                                                                    <span id={commonService.generateGlobalClickTrackerID("RNXisell", "on-the-book-ota-revenue", item)}
                                                                        className={`${selectedTdIndexRef.current === index
                                                                            ? "singleDateSummarySpan"
                                                                            : ""
                                                                            }`}
                                                                        onClick={(e) => {
                                                                            singleDateSelectedDateRef.current = item.dates;

                                                                            handleFilterBtnClick(e);
                                                                            selectedTdIndexRef.current = index;
                                                                        }}
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        {item.ota_sold
                                                                            ? item.ota_sold
                                                                            : 0}
                                                                    </span>

                                                                </td>
                                                                <td className=" text-end">
                                                                    {item.ota_revenue
                                                                        ? commonService.formateAmount(
                                                                            item.ota_revenue
                                                                        )
                                                                        : commonService.formateAmount(0)}
                                                                </td>
                                                                <td className=" text-end perbackground perbackground-adr" value={item.adr_otb}>
                                                                    {item.adr_otb
                                                                        ? commonService.formateAmount(
                                                                            item.adr_otb
                                                                        )
                                                                        : commonService.formateAmount(0)}
                                                                </td>

                                                                {
                                                                    ShowHNF &&
                                                                    <>
                                                                        <td className="border-right text-center">
                                                                            {item.cm_roomsold}
                                                                        </td>
                                                                        <td className="text-center">
                                                                            {commonService.formateAmount(item.cm_revenue ? item.cm_revenue : 0)}
                                                                        </td>

                                                                        <td className=" text-center">
                                                                            {item.cm_availability}
                                                                        </td>
                                                                    </>
                                                                }

                                                                {otbPickupMatch ? (
                                                                    <>
                                                                        <td className="border-right text-center perbackground perbackground-room" value={otbPickupMatch.rms}>
                                                                            {otbPickupMatch.rms}
                                                                        </td>
                                                                        <td className=" text-end">
                                                                            {otbPickupMatch.rev
                                                                                ? commonService.formateAmount(
                                                                                    otbPickupMatch.rev
                                                                                )
                                                                                : commonService.formateAmount(0)}

                                                                        </td>
                                                                        <td className="text-end">
                                                                            {otbPickupMatch.adr
                                                                                ? commonService.formateAmount(
                                                                                    otbPickupMatch.adr
                                                                                )
                                                                                : commonService.formateAmount(0)}
                                                                        </td>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td></td>
                                                                    </>
                                                                )}
                                                                {otbPickup7dayMatch ? (
                                                                    <>
                                                                        <td className="border-right text-center perbackground perbackground-room" value={otbPickup7dayMatch.rms}>
                                                                            {otbPickup7dayMatch.rms}
                                                                        </td>
                                                                        <td className=" text-end">
                                                                            {otbPickup7dayMatch.rev
                                                                                ? commonService.formateAmount(
                                                                                    otbPickup7dayMatch.rev
                                                                                )
                                                                                : commonService.formateAmount(0)}


                                                                        </td>
                                                                        <td className=" text-end">
                                                                            {otbPickup7dayMatch.adr
                                                                                ? commonService.formateAmount(
                                                                                    otbPickup7dayMatch.adr
                                                                                )
                                                                                : commonService.formateAmount(0)}
                                                                        </td>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td></td>
                                                                    </>
                                                                )}
                                                                <td className="border-right text-center">
                                                                    <div className="d-flex justify-content-center align-items-center">
                                                                        <p
                                                                            className={`${foreCastSpiderTextColor} ${forecastSpiderBorder} m-0`}
                                                                            style={{ padding: "2px" }}
                                                                        >
                                                                            {singleForecastData?.[0]?.RMS
                                                                                ? commonService.formateRoom(
                                                                                    singleForecastData?.[0]?.RMS
                                                                                )
                                                                                : 0}
                                                                        </p>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    {singleForecastData?.[0]?.R28AVG
                                                                        ? commonService.formateRoom(
                                                                            singleForecastData?.[0]?.R28AVG
                                                                        )
                                                                        : 0}
                                                                </td>
                                                                <td className="text-end">
                                                                    {singleForecastData?.[0]?.["Optimal Bar"]
                                                                        ? `${commonService.formateAmount(
                                                                            singleForecastData?.[0]?.["Optimal Bar"]
                                                                        )}`
                                                                        : `${commonService.formateAmount(0)}`}
                                                                </td>
                                                                <td className="border-right text-center">
                                                                    {api !== 0 &&
                                                                        marketTrendsData &&
                                                                        !dataLoading &&
                                                                        marketTrendsData?.find(
                                                                            (itemdfg) =>
                                                                                commonService.getDateInFormat(
                                                                                    itemdfg?.staydate
                                                                                ) ===
                                                                                commonService.getDateInFormat(
                                                                                    item?.dates
                                                                                )
                                                                        )?.trend}
                                                                </td>
                                                                <td className="border-right text-end">

                                                                    {api !== 0 &&
                                                                        marketTrendsData &&
                                                                        !dataLoading &&
                                                                        commonService.formateAmount(marketTrendsData?.find(
                                                                            (itemdfg) =>
                                                                                commonService.getDateInFormat(
                                                                                    itemdfg?.staydate
                                                                                ) ===
                                                                                commonService.getDateInFormat(
                                                                                    item?.dates
                                                                                )
                                                                        )?.avg_7_day_rate)}
                                                                </td>
                                                                <td className="border-right text-end">

                                                                    {api !== 0 &&
                                                                        marketTrendsData &&
                                                                        !dataLoading &&
                                                                        commonService.formateAmount(marketTrendsData?.find(
                                                                            (itemdfg) =>
                                                                                commonService.getDateInFormat(
                                                                                    itemdfg?.staydate
                                                                                ) ===
                                                                                commonService.getDateInFormat(
                                                                                    item?.dates
                                                                                )
                                                                        )?.avg_minus_current)
                                                                    }

                                                                </td>
                                                                {
                                                                    ShowRateOnCM &&
                                                                    <td className="border-right text-end rateoncm">
                                                                        {api !== 0 &&
                                                                            onTheBook &&
                                                                            !dataLoading &&
                                                                            commonService.formateAmount(
                                                                                onTheBook?.find(
                                                                                    (itemdfgg) =>
                                                                                        commonService.getDateInFormat(
                                                                                            itemdfgg?.dates
                                                                                        ) ===
                                                                                        commonService.getDateInFormat(
                                                                                            item?.dates
                                                                                        )
                                                                                )?.rate_on_cm
                                                                            )}
                                                                    </td>
                                                                }

                                                                {rateShopListData && (
                                                                    <>
                                                                        <td
                                                                            className={`text-end border-right ${isSelfData?.[0]?.Rate <
                                                                                avgCompetitor
                                                                                ? "greenText"
                                                                                : "redText"
                                                                                }`}
                                                                        >
                                                                            {isSelfData?.length > 0
                                                                                ? `${commonService.formateAmount(
                                                                                    isSelfData[0]?.Rate
                                                                                )}`
                                                                                : `${commonService.formateAmount(0)}`}
                                                                        </td>
                                                                        <td className={`text-end fontsize10px minwidth30px ${SelfDataRateDiff ? SelfDataRateDiff > 0 ? "greenText" : "redText" : ""}`}>{SelfDataRateDiff ? commonService.formateAmount(SelfDataRateDiff) : ""}</td>
                                                                    </>
                                                                )}
                                                                {rateShopListData && (
                                                                    <>
                                                                        <td id={commonService.generateGlobalClickTrackerID("RNXisell", "td-onclick", item)}
                                                                            className="text-end cursorPointer border-right"
                                                                            onClick={() => {
                                                                                setClickedDate(item?.dates);
                                                                                setToolsSummaryModal(true);
                                                                            }}
                                                                        >
                                                                            {avgCompetitor
                                                                                ? `${commonService.formateAmount(avgCompetitor)}`
                                                                                : `${commonService.formateAmount(0)}`}
                                                                        </td>
                                                                        <td className={`text-end fontsize10px minwidth30px ${avgCompetitorRateDiff ? avgCompetitorRateDiff > 0 ? "greenText" : "redText" : ""}`}>{avgCompetitorRateDiff ? commonService.formateAmount(avgCompetitorRateDiff) : ""}</td>
                                                                    </>
                                                                )}
                                                                {dataExistsOrNot?.length > 0
                                                                    ? rateShopListData?.map((x) => {
                                                                        if (
                                                                            x.CheckInDate ===
                                                                            moment(item?.dates).format(
                                                                                "YYYY-MM-DD"
                                                                            ) &&
                                                                            x.IsSelf === false
                                                                        ) {
                                                                            let RateDiff = 0;
                                                                            let pd = past_rateShopListData.filter((px) => px.CheckInDate === moment(item?.dates).format("YYYY-MM-DD") && px.IsSelf === false & px.CompetitorID === x.CompetitorID);
                                                                            if (pd && pd.length > 0) {
                                                                                let PDRate = pd[0]?.Rate ? pd[0]?.Rate : 0;
                                                                                let Rate = x?.Rate ? x?.Rate : 0;
                                                                                RateDiff = parseInt(PDRate) - parseInt(Rate);
                                                                            }

                                                                            return (
                                                                                <>
                                                                                    {parseInt(x?.RateStatusCode) ===
                                                                                        201 ? (
                                                                                        <td className="text-end">
                                                                                            <img
                                                                                                className="cursorPointer sold-out-img"
                                                                                                title="Sold Out"
                                                                                                src={soldOutIcon}
                                                                                                width={"10px"}
                                                                                                alt="soldout"
                                                                                            />
                                                                                        </td>
                                                                                    ) : (
                                                                                        <td className="text-end">
                                                                                            {
                                                                                                x?.Rate
                                                                                                    ? <span title={`${parseFloat(x?.Rate) <= 0 && x?.RateStatusDesc ? x?.RateStatusDesc : ""}`}>{`${commonService.formateAmount(Math.round(x?.Rate))}`}</span>
                                                                                                    : <span title={`${x?.RateStatusDesc ? x?.RateStatusDesc : ""}`}>{`${commonService.formateAmount(0)}`}</span>
                                                                                            }

                                                                                        </td>
                                                                                    )}

                                                                                    <td className={`text-end fontsize10px minwidth30px ${RateDiff ? RateDiff > 0 ? "greenText" : "redText" : ""}`}>{RateDiff ? commonService.formateAmount(RateDiff) : ""}</td>
                                                                                </>
                                                                            );
                                                                        }
                                                                    })
                                                                    : rateShopListData?.map(
                                                                        (x, index) => {
                                                                            if (
                                                                                x.CheckInDate ===
                                                                                moment(
                                                                                    rateShopListData?.[0]
                                                                                        ?.CheckInDate
                                                                                ).format("YYYY-MM-DD") &&
                                                                                x.IsSelf === false
                                                                            ) {

                                                                                let RateDiff = 0;
                                                                                let pd = past_rateShopListData.filter((px) => px.CheckInDate === moment(item?.dates).format("YYYY-MM-DD") && px.IsSelf === false & px.CompetitorID === x.CompetitorID);
                                                                                if (pd && pd.length > 0) {
                                                                                    let PDRate = pd[0]?.Rate ? pd[0]?.Rate : 0;
                                                                                    let Rate = x?.Rate ? x?.Rate : 0;
                                                                                    RateDiff = parseInt(PDRate) - parseInt(Rate);
                                                                                }
                                                                                return (
                                                                                    <><td className="text-end">
                                                                                        $0
                                                                                    </td>
                                                                                        <td className={`text-end fontsize10px minwidth30px ${RateDiff ? RateDiff > 0 ? "greenText" : "redText" : ""}`}>{RateDiff ? commonService.formateAmount(RateDiff) : ""}</td></>
                                                                                );
                                                                            }
                                                                        }
                                                                    )}

                                                            </tr>
                                                        </>
                                                    );
                                                })}
                                            </>
                                        )}
                                    </>
                                )}
                                {api === 0 || loading || dataLoading ? (
                                    <tr>
                                        <td className="text-center">Total</td>
                                        <td className="border-right text-center">{0}</td>
                                        <td className="border-right text-center">{0}</td>
                                        <td className="border-right text-center">{0}%</td>
                                        <td className="border-right text-center">{0}</td>
                                        <td className="border-right text-center">{0}</td>
                                        <td className="border-right text-center">{0}</td>
                                        <td className="border-right text-end">
                                            {commonService.formateAmount(0)}
                                        </td>
                                        <td className="border-right text-end">
                                            {commonService.formateAmount(0)}
                                        </td>
                                        <td className="border-right text-end">
                                            {commonService.formateAmount(0)}
                                        </td>
                                        <td className="border-right text-center">{0}</td>
                                        <td className="border-right text-end">
                                            {commonService.formateAmount(0)}
                                        </td>
                                        <td className="border-right text-end">
                                            {commonService.formateAmount(0)}
                                        </td>
                                        <td className="border-right text-center">{0}</td>
                                        <td className="border-right text-end">
                                            {commonService.formateAmount(0)}
                                        </td>
                                        <td className="border-right text-end">
                                            {commonService.formateAmount(0)}
                                        </td>
                                    </tr>
                                ) : (
                                    (() => {
                                        const totals = onTheBook?.reduce(
                                            (acc, val) => {
                                                acc.inventory += Number(val?.inventory || 0);
                                                acc.rooms_availtosell += Number(
                                                    val?.rooms_availtosell || 0
                                                );
                                                acc.superior_room += Number(
                                                    val?.superior_room || 0
                                                );
                                                acc.inventory_open += Number(
                                                    val?.inventory_open || 0
                                                );
                                                acc.ota_sold += Number(val?.ota_sold || 0);
                                                acc.ota_revenue += Number(
                                                    val?.ota_revenue || 0
                                                );
                                                acc.recommended_rate += Number(
                                                    val?.recommended_rate || 0
                                                );
                                                acc.adr_otb += Number(val?.adr_otb || 0);

                                                acc.cm_roomsold += Number(val?.cm_roomsold || 0);
                                                acc.cm_revenue += Number(val?.cm_revenue || 0);
                                                acc.cm_availability += Number(val?.cm_availability || 0);
                                                return acc;
                                            },
                                            {
                                                inventory: 0,
                                                rooms_availtosell: 0,
                                                superior_room: 0,
                                                inventory_open: 0,
                                                ota_sold: 0,
                                                ota_revenue: 0,
                                                recommended_rate: 0,
                                                adr_otb: 0,
                                                cm_roomsold: 0,
                                                cm_revenue: 0,
                                                cm_availability: 0,
                                            }
                                        );

                                        const avgInventoryOpen = onTheBook?.length
                                            ? Math.round(
                                                totals.inventory_open / onTheBook.length
                                            )
                                            : 0;

                                        const otbPickupTotals = otbPickup?.reduce(
                                            (acc, val) => {
                                                acc.adr += Number(val?.adr || 0);
                                                acc.rev += Number(val?.rev || 0);
                                                acc.rms += Number(val?.rms || 0);
                                                return acc;
                                            },
                                            { adr: 0, rev: 0, rms: 0 }
                                        );
                                        const otbPickup7DaysTotals = otbPickup7Days?.reduce(
                                            (acc, val) => {
                                                acc.adr += Number(val?.adr || 0);
                                                acc.rev += Number(val?.rev || 0);
                                                acc.rms += Number(val?.rms || 0);
                                                return acc;
                                            },
                                            { adr: 0, rev: 0, rms: 0 }
                                        );

                                        return (
                                            <tr>
                                                <td className="text-center">Total</td>
                                                <td className="text-center"></td>
                                                <td className="border-right text-center">
                                                    {totals.inventory}
                                                </td>
                                                <td className="border-right text-center">
                                                    {totals.rooms_availtosell}
                                                </td>
                                                <td className="border-right text-center">
                                                    {totals.superior_room}
                                                </td>
                                                <td className="border-right text-center">
                                                    {avgInventoryOpen}%
                                                </td>
                                                <td className="border-right text-center">
                                                    {totals.ota_sold}
                                                </td>
                                                <td className="border-right text-end">
                                                    {totals.ota_revenue
                                                        ? commonService.formateAmount(
                                                            totals.ota_revenue
                                                        )
                                                        : commonService.formateAmount(0)}
                                                </td>
                                                <td className="border-right text-end">
                                                    {totals.ota_revenue && totals.ota_sold
                                                        ? commonService.formateAmount(
                                                            totals.ota_revenue / totals.ota_sold
                                                        )
                                                        : commonService.formateAmount(0)}
                                                </td>
                                                {
                                                    ShowHNF &&
                                                    <>
                                                        <td className="border-right text-center">
                                                            {totals.cm_roomsold}
                                                        </td>
                                                        <td className="text-center">
                                                            {totals.cm_revenue}
                                                        </td>
                                                        <td className=" text-center">
                                                            {totals.cm_availability}
                                                        </td>
                                                    </>
                                                }





                                                <td className="border-right text-center">
                                                    {commonService.formateRoom(otbPickupTotals?.rms)}
                                                </td>
                                                <td className="border-right text-end">
                                                    {otbPickupTotals?.rev
                                                        ? commonService.formateAmount(
                                                            otbPickupTotals?.rev
                                                        )
                                                        : commonService.formateAmount(0)}
                                                </td>
                                                <td className="border-right text-end">
                                                    {/* {otbPickupTotals?.adr && onTheBook.length
                                                        ? commonService.formateAmount(
                                                            otbPickupTotals?.adr / onTheBook.length
                                                        )
                                                        : commonService.formateAmount(0)} */}
                                                    {otbPickupTotals?.adr && onTheBook.length
                                                        ? commonService.formateAmount(
                                                            safeDivide(otbPickupTotals?.rev, otbPickupTotals?.rms)
                                                        )
                                                        : commonService.formateAmount(0)}

                                                </td>
                                                <td className="border-right text-center">
                                                    {commonService.formateRoom(otbPickup7DaysTotals?.rms)}
                                                </td>
                                                <td className="border-right text-end">
                                                    {otbPickup7DaysTotals?.rev
                                                        ? commonService.formateAmount(
                                                            otbPickup7DaysTotals?.rev
                                                        )
                                                        : commonService.formateAmount(0)}
                                                </td>
                                                <td className="border-right text-end">
                                                    {otbPickup7DaysTotals?.adr && onTheBook.length
                                                        ? commonService.formateAmount(
                                                            safeDivide(otbPickup7DaysTotals?.rev, otbPickup7DaysTotals?.rms)
                                                        )
                                                        : commonService.formateAmount(0)}
                                                    {/* {otbPickup7DaysTotals?.adr && onTheBook.length
                                                        ? commonService.formateAmount(
                                                            otbPickup7DaysTotals?.adr / onTheBook.length
                                                        )
                                                        : commonService.formateAmount(0)} */}
                                                </td>
                                                <td className="border-right text-center" colSpan="100"></td>
                                            </tr>
                                        );
                                    })()
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>

            <Overlay
                show={ONTHEBOOKS.IsDisplay}
                target={ONTHEBOOKS.Target}
                placement={ONTHEBOOKS.Position}
            >
                <Popover
                    id="popover-contained"
                    className="SingleDateSummaryModalPopoverMain"
                    style={{ zIndex: 999999 }}
                >
                    <div className="horizontal-menu-option active">
                        <RNX_SingleDateSummaryModal
                            closeModal={closeSingleDate}
                            asOfDate={para?.asOfDate}
                            selectedDate={singleDateSelectedDateRef.current}
                            pickupDate={
                                selectSevenDayPickupDate
                                    ? selectSevenDayPickupDate
                                    : sevenMaxDateRef.current
                            }
                            propertyDetail={{ propertyCode: para?.propertyCode }}
                        />
                    </div>
                </Popover>
            </Overlay>

            {flagModal && (
                <FlagPopup
                    showModal={flagModal}
                    closeModal={() => setFlagModal(false)}
                    data={flagModalData}
                />
            )}
            {showTicketModal && (
                <EventViewModal
                    showModal={showTicketModal}
                    closeModal={() => setShowTicketModal(false)}
                    eventDetails={eventListPropsRef.current}
                    selectedDate={selectedEventDateRef.current}
                    getEventList={getEventList}
                />
            )}
            {showToolsSummaryModal && (
                <ToolsSummaryModal
                    showToolsSummaryModal={showToolsSummaryModal}
                    closeToolsSummaryModal={() => setToolsSummaryModal(false)}
                    selectedDate={ClickedDate}
                    propertyDetail={para?.propertyDetail}
                />
            )}
            {api !== 0 && (
                <Comments widgetDetails={para} editorId={"editor" + tblids.rnxtbl1} />
            )}
            {showNoteSidebar && (
                <WidgetNote
                    show={showNoteSidebar}
                    handleClose={closeNoteSideBar}
                    // widgetId={para?.widgetId}
                    widgetId={0}
                    propertyId={propertyDetailFromRTK?.propertyid}
                    rowTitle={para?.rowTitle}
                    dateForNote={clickedDateForNote.current}
                />
            )}
            {
                widgetModal && (
                    <WidgetDetailModal
                        showModal={widgetModal}
                        closeModal={closeWidgetModal}
                        data={widgetDetailRef.current}
                    />
                )
            }
        </div>
    );
};
export default RNXisell;
